import { OrientationIcon } from '../OrientationIcon/OrientationIcon';
import type { DisplayOrientation } from '../../../data/types';
import './OrientationSegmented.css';

interface OrientationSegmentedProps {
  value: DisplayOrientation | null;
  onChange: (value: DisplayOrientation) => void;
  disabled?: boolean;
}

const OPTIONS: { value: DisplayOrientation; label: string }[] = [
  { value: 'Portrait', label: 'Portrait' },
  { value: 'Landscape', label: 'Landscape' },
];

export function OrientationSegmented({ value, onChange, disabled }: OrientationSegmentedProps) {
  return (
    <div className="orientation-segmented-root">
      {OPTIONS.map((opt) => {
        const active = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            disabled={disabled}
            onClick={() => onChange(opt.value)}
            className={`orientation-segmented-option ${active ? 'is-active' : ''}`}
          >
            <OrientationIcon
              orientation={opt.value}
              size={18}
              color={active ? 'var(--accent, #D23A3B)' : 'var(--t3, #9CA3B8)'}
            />
            <span className="orientation-segmented-label">
              {opt.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
